import type { CalendarEntry, LinkedCalendarEntryV2, LocalCalendarEntry } from 'owa-graph-schema';

import { isLinkedCalendarEntry } from './isLinkedCalendarEntry';
import { isLinkedCalendarEntryV2 } from './isLinkedCalendarEntryV2';
import { isBootFeatureEnabled } from 'owa-metatags';

export function canViewPrivateEvents(calendarEntry: CalendarEntry): boolean {
    // Old-model linked calendars do not expose CanViewPrivateItems directly. Their equivalent
    // permission is populated from GetCalendarFolderConfiguration on EffectiveRights.
    return (
        (isBootFeatureEnabled('cal-enable-HybridModel-for-calendarSharing') &&
            isLinkedCalendarEntryV2(calendarEntry) &&
            (calendarEntry as LinkedCalendarEntryV2)?.CanViewPrivateItems) ||
        (calendarEntry as LocalCalendarEntry)?.CanViewPrivateItems ||
        (isLinkedCalendarEntry(calendarEntry) && !!calendarEntry.EffectiveRights?.ViewPrivateItems)
    );
}
